import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Divider,
  IconButton,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { capitalizeFirstLetter } from "../../utils/helpers";

export default function ViewFeedback({ open, onClose, data }) {
  if (!data) return null;

  const {
    users,
    message,
    feedback,
    rating,
    createdAt,
  } = data;

  const displayName = users?.[0]?.firstName + " " + users?.[0]?.lastName || "-";
  const displayEmail = users?.[0]?.email || "-";
  const displayMessage = message || feedback || "N/A";
  const displayRating = rating || 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ pr: 5 }}>
        Feedback Details
        <IconButton
          aria-label="Close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {/* User Information */}
        <Box mb={2}>
          <Typography variant="body1" gutterBottom>
            <strong>Name:</strong> {capitalizeFirstLetter(displayName)}
          </Typography>
          <Typography variant="body1" gutterBottom>
            <strong>Email:</strong> {displayEmail}
          </Typography>
          {displayRating > 0 && (
            <Box mt={1} mb={1}>
              <Typography variant="body2" component="span" sx={{ mr: 1 }}>
                <strong>Rating:</strong>
              </Typography>
              <Chip
                label={`${displayRating} ⭐`}
                color="primary"
                size="small"
                variant="outlined"
              />
            </Box>
          )}
          {createdAt && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              <strong>Submitted:</strong>{" "}
              {dayjs(createdAt).format("MMM D, YYYY h:mm A")}
            </Typography>
          )}
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Feedback Message */}
        <Box>
          <Typography variant="subtitle2" gutterBottom>
            <strong>Feedback Message:</strong>
          </Typography>
          <Box
            sx={{
              bgcolor: "grey.50",
              p: 2,
              borderRadius: 1,
              border: "1px solid",
              borderColor: "divider",
              mt: 1,
            }}
          >
            <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
              {capitalizeFirstLetter(displayMessage)}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

